import React, { Fragment } from 'react';
import { Row, Col,Table } from 'reactstrap';


const CustomerDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <td>{data.user?.name}</td>
                            </tr>
                            <tr>
                                <th>Mobile Number</th>
                                <td>{data.user?.phone_no}</td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td>{data.user?.email}</td>
                            </tr>
                            <tr>
                                <th>Address</th>
                                <td>{data.user?.Address}</td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{data.user?.state}</td>
                            </tr>
                            <tr>
                                <th>City</th>
                                <td>{data.user?.city}</td>
                            </tr>
                            <tr>
                                <th>Pincode</th>
                                <td>{data.user?.pin_code}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default CustomerDetails;